module.exports = __webpack_public_path__ + "static/media/Graham Perkins.7d3e9ceb.png";